import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { ApiService } from "@/services/GuneApiService.js";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    selectRestaurant: null,
    restaurants: [],
    auth: null,
    template: [],
    isOpenSideBar: false,
  },
  mutations: {
    setRestaurants(state, newRestaurants) {
      state.restaurants.splice(0, state.restaurants.length);

      for (const restaurant of newRestaurants) {
        state.restaurants.push(restaurant);
      }
    },
    setRestaurant(state, newRestaurant) {
      state.selectRestaurant = newRestaurant;
    },
    setAuth(state, newAuthToken) {
      // eslint-disable-next-line no-console

      state.auth = newAuthToken.access_token;
      // localStorage.setItem('auth', newAuthToken.data.access_token)

      // ApiService().defaults.headers.common['Authorization'] = `Bearer ${newAuthToken.data.access_token}`;

      this.dispatch("getRestaurants");
    },
    setOpenSideBar(state, value) {
      state.isOpenSideBar = value;
    },

    logout(state) {
      state.auth = null;
      state.selectRestaurant = null;
      state.restaurants.splice(0, state.restaurants.length);
    },
  },
  getters: {
    isAuthenticated: (state) => {
      if (state.auth == null) return false;
      return true;
    },
  },
  actions: {
    getRestaurants: (context) => {
      // if (this.getters.isAuthenticated === false) return
      ApiService()
        .get("/gune", {
          params: {
            // siteid: siteid
          },
        })
        .then((res) => {
          context.commit("setRestaurants", res.data);
        })
        .catch(function (err) {
          err;
        });
    },
  },
});
